export const WindowSize = () => {
  const w = window
  const d = document
  const e = d.documentElement
  const g = d.getElementsByTagName('body')[0]
  const x = e.clientWidth || g.clientWidth || w.innerWidth
  const y = e.clientHeight || g.clientHeight || w.innerHeight
  return {x, y}
}

export const openLinksInNewWindow = () => {
  const links = document.links
  let i = -1

  while (++i < links.length) {
    links[i].target = '_blank'
    links[i].setAttribute('rel', 'noopener noreferrer')
  }
}
